import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebApiService } from './web-api.service';
@Injectable({
  providedIn: 'root'
})
export class IdentityAuthorizeService {
  constructor(private _webApiService: WebApiService) { }
  getIdentityUserType(email: string): Observable<any> {
    return this._webApiService.postIdentity(apiRoutes.getIdentityUserType(email));
  }
}
const apiRoutes = {
  getIdentityUserType: (email: string) => `/Authorize/AderantUser?email=${email}`
};